module.exports = __webpack_public_path__ + "static/assets/492b8fe8770723b5b19cd10567a8a2a6.png";